import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Select from 'react-select';
const SelectCustom = ({ options, placeholder, onChange, value, label, loader, isDisabled, onFocus }) => {
    const noOptionsMessage = () => {
        return 'Нет данных';
    };
    const loadingMessage = () => {
        return 'Загрузка...';
    };
    const customStyles = {
        menu: (provided) => (Object.assign(Object.assign({}, provided), { zIndex: 4 })),
    };
    return (_jsxs(_Fragment, { children: [(label === null || label === void 0 ? void 0 : label.length) && _jsx("label", Object.assign({ style: { fontWeight: 'bold', color: '#454545' } }, { children: label })), _jsx("div", Object.assign({ style: { marginTop: '5px' } }, { children: _jsx(Select, { noOptionsMessage: noOptionsMessage, options: options, placeholder: placeholder, isLoading: loader, loadingMessage: loadingMessage, onChange: onChange, value: value, isDisabled: isDisabled, onFocus: onFocus, isSearchable: false, styles: customStyles }) }))] }));
};
export default SelectCustom;
